<template>
  <div>
    <div class="row no-gutters">
      <div class="col pr-2" id="application-approved-date">
        <div class="small text-muted-more" id="loan-application-approval-date-label">{{$t('LoanApplicationTimeline.applicationApproved')}}</div>
        <div class="text-muted small" id="loan-application-approval-date">{{$d(application.approvedDate)}}</div>
      </div>
      <div class="col pr-2" id="application-offered-amount" v-if="application.offeredAmount && application.offeredPeriodInMonths">
        <div class="small text-muted-more">{{$t('LoanApplicationTimeline.offeredAmount')}}</div>
        <div class="text-amount text-muted small">{{ $n(application.offeredAmount, 'currencyNoDecimals') }}</div>
      </div>
      <div class="col" id="application-offered-period" v-if="application.offeredAmount && application.offeredPeriodInMonths">
        <div class="small text-muted-more">{{$t('LoanApplicationTimeline.offeredPeriod')}}</div>
        <div class="text-amount text-muted small">{{$tc('LoanApplicationTimeline.month', application.offeredPeriodInMonths)}}</div>
      </div>
    </div>
    <div class="row no-gutters pt-3" v-if="application.refinanceableAmount">
      <div class="col pr-2"  v-if="application.offeredAmount && application.offeredPeriodInMonths">
        <div class="small text-muted-more">{{$t('LoanApplicationTimeline.youWillReceive')}}</div>
        <div class="text-amount text-muted small">{{$n(application.offeredAmount - application.refinanceableAmount, 'currency')}}</div>
      </div>
      <div class="col pr-2">
        <div class="small text-muted-more">{{$t('LoanApplicationTimeline.refinanceableAmount')}}</div>
        <div class="text-amount text-muted small">{{ $n(application.refinanceableAmount, 'currencyNoDecimals') }}</div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ApprovedStageComponent',
  props: ['application']
}
</script>
